module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[40]161.44f91f1.woff2";